"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWaitForGiftResearchingEffect = void 0;

var _react = require("react");

var _reactRedux = require("react-redux");

var _gift = require("../store/gift/gift.selector");

var _gift2 = require("../store/gift/gift.actions");

var _giftResearchTypes = require("../constants/giftResearchTypes.constant");

var useWaitForGiftResearchingEffect = function useWaitForGiftResearchingEffect() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var isResearchProcessing = (0, _reactRedux.useSelector)(_gift.getIsResearchProcessing);
  var researchType = (0, _reactRedux.useSelector)(_gift.getGiftResearchType);
  (0, _react.useEffect)(function () {
    if (isResearchProcessing && researchType === _giftResearchTypes.researchTypes.AI) {
      dispatch((0, _gift2.waitForInstantResearchStart)());
    }

    return function () {
      return dispatch((0, _gift2.waitForInstantResearchCancel)());
    };
  }, [dispatch, isResearchProcessing, researchType]);
};

exports.useWaitForGiftResearchingEffect = useWaitForGiftResearchingEffect;